import React from 'react'

const HighlightText = ({text}) => {
  return (
    <span className="font-bold  text-richblue-100 ">
    {" "}
       {text} 
    </span>
  )
}
// bg-gradient-to-b from-[#3b3737] to-[#282897]
export default HighlightText